import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import loaderimage from "../../images/giphy.gif";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Complaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [filteredComplaints, setFilteredComplaints] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [operationType, setOperationType] = useState("");
  const [selectedComplaint, setSelectedComplaint] = useState(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_URL + "complaints/";

  const fetchComplaints = async () => {
    try {
      setLoader(true);
      const token = localStorage.getItem('jwttoken');
      setError(null);
      const response = await axios.get(`${API_BASE_URL}getcomplaints`, {
        headers: {
          'x-access-token': token
        }
      });
      setComplaints(response.data);
      setFilteredComplaints(response.data);
    } catch (error) {
      setError(error.response?.data?.message || "Failed to fetch complaints.");
      setFailureMessage(error.response?.data?.message || "Failed to fetch complaints.");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchComplaints();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };


  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (!searchTerm) {
        setFilteredComplaints(complaints);
      } else {
        const filtered = complaints.filter(
          (c) =>
            c.name?.toLowerCase().includes(searchTerm) ||
            c.email?.toLowerCase().includes(searchTerm) ||
            c.subject?.toLowerCase().includes(searchTerm)
        );
        setFilteredComplaints(filtered);
      }
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchTerm, complaints]);


  const handleAPIAction = async (url, method, data, successMessage, errorMessage) => {
    try {
      await axios({ url, method, data });
      setSuccessMessage(successMessage);
      setShowSuccessModal(true);
      fetchComplaints();
    } catch (error) {
      console.error(errorMessage, error);
      setFailureMessage(error.response?.data?.message || errorMessage);
      setShowFailureModal(true);
    } finally {
      setModalShow(false);
      setSelectedComplaint(null);
    }
  };

  const confirmDeleteComplaint = (id) => {
    setModalMessage("Are you sure you want to delete this complaint?");
    setOperationType("Delete");
    setSelectedComplaint({ id });
    setModalShow(true);
  };

  const confirmUpdateComplaintStatus = (id, status) => {
    const updatedStatus = status === "Pending" ? "Resolved" : "Pending";
    setModalMessage(`Mark complaint as ${updatedStatus}?`);
    setOperationType("UpdateStatus");
    setSelectedComplaint({ id, updatedStatus });
    setModalShow(true);
  };

  const handleModalConfirmation = async (isConfirmed) => {
    setModalShow(false);
    if (isConfirmed) {
      if (operationType === "Delete" && selectedComplaint) {
        const url = `${API_BASE_URL}deletecomplaint/${selectedComplaint.id}`;
        handleAPIAction(url, "PUT", null, "Complaint deleted successfully", "Error deleting complaint");
      } else if (operationType === "UpdateStatus" && selectedComplaint) {
        const { id, updatedStatus } = selectedComplaint;
        const url = `${API_BASE_URL}updatecomplaint/${id}`;
        const data = { status: updatedStatus };
        handleAPIAction(
          url,
          "PUT",
          data,
          `Complaint marked as ${updatedStatus}`,
          "Error updating complaint status"
        );
      }
    }
  };


  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">Complaints Management</h2>
        <div className="d-flex gap-2 align-items-center" style={{ width: "420px" }}>

          <span className="fw-bold text-secondary text-nowrap">
            {filteredComplaints.length} results
          </span>
          <input
            type="text"
            className="form-control flex-grow-1"
            placeholder="Search by Name, Email, or Subject"
            value={searchTerm}
            onChange={handleSearch}
          />


        </div>
      </div>

      <div className="card shadow-sm border-0 rounded">
        <div className="card-header bg-info border-bottom py-3">
          <h5 className="mb-0 text-white">Complaints List</h5>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table className="table table-hover align-middle mb-0">
              <thead className="bg-light text-center">
                <tr>
                  <th>#</th>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Subject</th>
                  <th>Message</th>
                  <th>Status</th>
                  <th colSpan={2}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan={10} className="text-center py-2">
                      <img src={loaderimage} alt="Loading..." height="40" />
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={10} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
                        Oops! Something went wrong. Please try again later.
                      </div>
                    </td>
                  </tr>
                ) : filteredComplaints?.length > 0 ? (
                  filteredComplaints.map((complaint, index) => (
                    <tr key={complaint.id} className="border-bottom">
                      <td>{index + 1}</td>
                      <td>{complaint.user_id}</td>
                      <td>{complaint.name}</td>
                      <td>{complaint.mobile}</td>
                      <td>{complaint.email}</td>
                      <td>{complaint.subject}</td>
                      <td>{complaint.message}</td>
                      <td>
                        <span
                          className={`badge ${
                            complaint.status === "Pending" ? "bg-warning" : "bg-success"
                            }`}
                        >
                          {complaint.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button
                            onClick={() => confirmUpdateComplaintStatus(complaint.id, complaint.status)}
                            className={`btn btn-sm ${
                              complaint.status === "Pending" ? "btn-outline-success" : "btn-outline-danger"
                              }`}
                          >
                            {complaint.status === "Pending" ? "Mark Resolved" : "Mark Pending"}
                          </button>
                          <Link
                            to={`/ComplaintsView/${complaint.id}`}
                            className="btn btn-sm btn-outline-warning"
                          >
                            View
                          </Link>
                          <button
                            onClick={() => confirmDeleteComplaint(complaint.id)}
                            className="btn btn-sm btn-outline-secondary"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))

                ) : (
                  <tr>
                    <td colSpan={10} className="text-center  text-muted fw-bold">
                      <div className="alert alert-secondary text-center m-3" role="alert">
                        No Complaints available
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={modalShow}
        modalMessage={modalMessage}
        operationType="Ok"
        onHide={() => setModalShow(false)}
        confirmation={handleModalConfirmation}
      />
      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={5000}
      />
    </div>
  );
};

export default Complaints;
